import Vue from 'vue'
import Vuex from 'vuex'

import state from './serviceListState'
import getters from './serviceListGetters'
import actions from './serviceListActions'
import mutations from './serviceListMutations'

export default {
  namespaced : true,
  state : state,
  getters : getters,
  actions : actions,
  mutations : mutations
}

